function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaution = props => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    overflow: "visible",
    enableBackground: "new 0 0 32 32"
  },
  viewBox: "0 0 32 32",
  xmlSpace: "preserve",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  style: {
    fill: "#fec900"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 25h3v-3h-3v3zm0-19v13h3V6h-3z",
  style: {
    fill: "#fff"
  }
}));
export default SvgCaution;